"use strict";
function parse() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var newClass = "";
    for (var i = 0; i < args.length; i++) {
        var arg = args[i];
        var type = typeof arg;
        if (arg) {
            if (type === "string" || (type === "number" && arg > 0)) {
                newClass += arg + " ";
            }
            else if (Array.isArray(arg) && arg.length) {
                for (var n = 0; n < arg.length; n++) {
                    newClass += parse(arg[n]) + " ";
                }
            }
            else {
                var keys = Object.keys(arg);
                for (var k = 0; k < keys.length; k++) {
                    var key = keys[k];
                    var value = arg[key];
                    if (typeof value === "boolean" && value) {
                        newClass += key + " ";
                    }
                    else if (Array.isArray(value) && value.length) {
                        var arrayClass = key + " ";
                        for (var n = 0; n < value.length; n++) {
                            if (!value[n]) {
                                arrayClass = "";
                                n = value.length;
                            }
                        }
                        newClass += arrayClass;
                    }
                    else if (value) {
                        newClass += value + " ";
                    }
                }
            }
        }
    }
    return newClass.trim();
}
module.exports = parse;
